import { router } from 'expo-router';
import {
    BodyMediumEmphasized,
    BodySmallRegular,
    useThemeColors,
    View,
    XStack,
    YStack,
} from 'smoothie';
import { LinearGradient } from 'tamagui/linear-gradient';

import { SIDEBAR_CONTENT_MAX_WIDTH } from '../../../common/utils/homeUtils';
import GuideAvatars from '../../../onboarding/components/GuideAvatars';

/**
 * "Want an expert's advice?" booking card shown on the no-session home screen
 * under the GOYO (go-on-your-own) flow.
 */
export const ExpertAdviceCard = ({
    maxWidth = SIDEBAR_CONTENT_MAX_WIDTH,
    title,
    text,
}: {
    maxWidth?: number;
    title?: string;
    text?: string;
}) => {
    const { getColor } = useThemeColors();
    const peachGradient = [getColor('$peachLight'), getColor('$peach')];

    const defaultTitle = 'Want a Guide\u2019s advice?';
    const defaultText =
        'If you need help refining your Money Map, meet with a Guide.';

    return (
        <YStack width="100%" $sm={{ maxWidth, alignSelf: 'center' }}>
            <YStack
                backgroundColor="$gray200"
                borderRadius={24}
                padding={16}
                gap={16}
            >
                <YStack gap={4} alignItems="flex-start">
                    {/* Guide avatars pill */}
                    <LinearGradient
                        colors={peachGradient}
                        locations={[0.1479, 0.9608]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 1 }}
                        style={{ padding: 4, borderRadius: 9999 }}
                    >
                        <GuideAvatars size="medium" />
                    </LinearGradient>
                    <BodyMediumEmphasized color="$black">
                        {title ?? defaultTitle}
                    </BodyMediumEmphasized>
                    <BodySmallRegular color="$gray1000">
                        {text ?? defaultText}
                    </BodySmallRegular>
                </YStack>

                {/* Book a session button */}
                <XStack
                    onPress={() => {
                        router.navigate('/onboarding/book-first-session');
                    }}
                    cursor="pointer"
                    alignItems="center"
                    justifyContent="center"
                    padding={16}
                    borderRadius={16}
                    overflow="hidden"
                    position="relative"
                    pressStyle={{ opacity: 0.85 }}
                >
                    <YStack
                        position="absolute"
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        zIndex={0}
                    >
                        <LinearGradient
                            colors={peachGradient}
                            start={[0, 0]}
                            end={[0, 1]}
                            width="100%"
                            height="100%"
                        />
                    </YStack>
                    <View zIndex={1}>
                        <BodyMediumEmphasized color="$peachDarkest">
                            Book a session
                        </BodyMediumEmphasized>
                    </View>
                </XStack>
            </YStack>
        </YStack>
    );
};

export default ExpertAdviceCard;
